module.exports = __webpack_public_path__ + "static/services1-08eff6968e4f090074ec41f5637754a2.png";